import React from 'react'

import { useCopyPasteFlowNode } from '../../hook/useCopyPasteFlowNode'
import { useDeleteNodeAndEdge } from '../../hook/useDeleteNodeAndEdge'

export const FlowEvent: React.FC = () => {
    useDeleteNodeAndEdge()
    useCopyPasteFlowNode()
    return <></>
}
